import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { onSessionChange } from './api/http';
import { borrarCachePersistente } from './lib/cachePersistente';
import { crearClienteConsultas } from './lib/clienteConsultas';
import './styles/tokens.css';
import './styles/app.css';
import './styles/island.css';
import './styles/diseno-a.css';
import './ui/prefs';

const qc = crearClienteConsultas();

// Al cerrar sesion (o si vence) se borran tambien las copias de las consultas guardadas en IndexedDB.
onSessionChange((s) => {
  if (!s) void borrarCachePersistente();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
